import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth';

export function RedirectHome() {
  const { user, isLoading } = useAuth();

  // Показываем загрузку пока проверяется авторизация
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Загрузка...</p>
        </div>
      </div>
    );
  }

  // Если пользователь авторизован - перенаправляем в dashboard
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  // Если не авторизован - перенаправляем на страницу входа
  return <Navigate to="/login" replace />;
}
